<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label for="enabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.enabled") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.enabled" class="form-check-input" type="checkbox" id="enabled">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="beforeTraderRequisites" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.cascadeBeforeTraderRequisites") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.beforeTraderRequisites" class="form-check-input" type="checkbox" id="beforeTraderRequisites">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.name") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.type") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`type`)">
            <Multiselect
              :class="parentProps.class"
              v-model="form.direction"
              :options="[Direction.PAY_IN, Direction.PAY_OUT]"
              :custom-label="(opt) => helper.trans(`direction.${opt}`)"
              :multiple="false"
              select-label="Select"
              placeholder=""
            >

            </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="currency" form="requisitesForm">
              <Multiselect id="currency"
                           class=""
                           v-model="form.currency"
                           :options="store.getters['currencyMethods/currencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="minAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.from_sum") }}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="form.minAmount">
          </div>
        </div>

        <div class="row mt-2">
          <label for="maxAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.to_sum") }}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="form.maxAmount">
          </div>
        </div>

        <div class="row mt-2">
          <label for="paymentOptions" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_options") }}</label>
          <div class="col-sm-8">
            <Multiselect id="paymentOptions"
                         v-model="form.paymentOptions"
                         :options="store.getters['currencyMethods/options']()"
                         :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="helper.trans('labels.payment_options')"
            >
            </Multiselect>
          </div>
        </div>

        <div class="row mt-2">
          <label for="paymentMethods" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_methods") }}</label>
          <div class="col-sm-8">
            <Multiselect id="paymentMethods"
                         v-model="form.paymentMethods"
                         :options="store.getters['currencyMethods/methods']()"
                         :custom-label="(opt:any) => helper.trans(`pay_methods.${opt}`)"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="helper.trans('labels.payment_methods')"
            >
              <template #option="props">
                <div class="d-flex flex-row align-items-center gap-2">
                  <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                  <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                </div>
              </template>
            </Multiselect>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.stores") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`storeIds`)">
              <StoreMultiselect
                :class="parentProps.class"
                :small="false"
                v-model="form.stores"
                :multiple="true"
              >
              </StoreMultiselect>
            </FormInputWrapper>
          </div>
        </div>

        <fieldset v-if="providerRatingEnabled" :disabled="form.isAsync" class="mt-2">
          <div class="row mt-2">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_rating") }}</label>
            <div class="col-sm-8">
              <small v-if="form.isAsync" class="text-muted d-block mb-2">{{ helper.trans("labels.provider_rating_sync_only") }}</small>
              <Multiselect
                :model-value="selectedRatingTypeOption"
                @update:model-value="onRatingTypeSelect"
                :options="ratingTypeSelectOptions"
                :custom-label="ratingTypeOptionLabel"
                track-by="value"
                :multiple="false"
                :allow-empty="false"
                select-label="Select"
                placeholder=""
              />
              <small class="text-muted d-block mt-2">{{ helper.trans("labels.provider_rating_manual_order_hint") }}</small>
            </div>
          </div>

          <div v-if="form.ratingType === 'mix_conversion'" class="row mt-2">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_rating_coefficient_a") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors('ratingA')">
                <input :class="parentProps.class" v-model="form.ratingA" type="text" class="form-control">
              </FormInputWrapper>
            </div>
          </div>

          <div v-if="form.ratingType === 'mix_conversion'" class="row mt-2">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_rating_coefficient_b") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors('ratingB')">
                <input :class="parentProps.class" v-model="form.ratingB" type="text" class="form-control">
              </FormInputWrapper>
            </div>
          </div>

          <div v-if="form.ratingType === 'mix_conversion'" class="row mt-2">
            <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_rating_coefficient_c") }}</label>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors('ratingC')">
                <input :class="parentProps.class" v-model="form.ratingC" type="text" class="form-control">
              </FormInputWrapper>
            </div>
          </div>
        </fieldset>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.providers") }}</label>
        </div>

        <div class="row mt-2">
          <div class="">
            <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
              <thead>
              <tr>
                <th></th>
                <th class="text-capitalize">{{helper.trans('labels.is_active')}}</th>
                <th class="text-capitalize">{{helper.trans('labels.name')}}</th>
                <th></th>
              </tr>
              </thead>
              <Sortable
                :list="form.providers"
                item-key="id"
                @end="onUpdate($event)"
                tag="tbody"
                class=""
                :options="{draggable: '.draggable', handle: '.drag-handle'}"
              >
                <template #item="{element, index}">
                  <tr class="draggable">
                    <td style="width: 0" class="p-0 position-relative">
                      <div class="d-flex flex-row">
                        <div class="d-flex align-items-center justify-content-center">
                         <span class="ms-3 badge" :class="getBadgeBackground(form.providers[index].priority)">{{ form.providers[index].priority }}</span>
                        </div>
                        <div class="drag-handle p-2 ps-4 pe-4 m-2">
                          <i class="fa-solid fa-grip-vertical"></i>
                        </div>
                      </div>
                      <a href="#" v-if="form.providers[index + 1]" class="link-provider" :class="{linked: isProviderLinked(index, index + 1)}" @click.prevent="linkProviders(index, index + 1)">
                        <i class="fa-solid fa-link p-2"></i>
                      </a>
                    </td>
                    <td style="width: 0">
                      <div class="form-check form-switch d-flex align-items-center">
                        <input  v-model="form.providers[index].enabled" class="form-check-input" type="checkbox" id="enabled">
                      </div>
                    </td>
                    <td  class="position-relative">
                      <Multiselect
                                   v-model="form.providers[index].providerId"
                                   class="multiselect-sm"
                                   :options="Object.keys(providers)"
                                   :custom-label="(opt) => providers[opt]._trader?.name"
                                   :multiple="false"
                                   select-label="Select"
                      >
                      </Multiselect>
                    </td>
                    <td class="text-end" style="width: 0">
                      <button type="button" @click.prevent="deleteProvider(index)" class="btn btn-sm btn-outline-danger"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                </template>
              </Sortable>
              <tfoot>
                <tr>
                  <td colspan="4">
                    <button type="button" @click.prevent="addProvider()" class="btn btn-sm  w-100 btn-outline-primary">{{ helper.trans('button.add') }}</button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, onMounted, watch, computed} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {api} from "@/service/APIClient";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import Multiselect from "vue-multiselect";
import {Direction} from "@/models/enum/Direction";
import CascadeFormDTO from "@/models/form/CascadeFormDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import ProviderDTO from "@/models/ProviderDTO";
import {Sortable} from "sortablejs-vue3";
import {Dictionary} from "@/types";
import TraderDTO from "@/models/TraderDTO";
import PaginationDTO from "@/models/PaginationDTO";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import CascadeProviderDTO from "@/models/CascadeProviderDTO";

type RatingTypeOption = { value: CascadeFormDTO['ratingType'] }

const ratingTypeSelectOptions: RatingTypeOption[] = [
  { value: null },
  { value: 'conversion' },
  { value: 'mix_conversion' },
]
const ratingTypeLabels: Record<string, string> = {
  manual: 'labels.provider_rating_manual',
  conversion: 'labels.provider_rating_conversion',
  mix_conversion: 'labels.provider_rating_mix_conversion',
}

export default defineComponent({
  props: {
    role: String,
    providerRatingEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StoreMultiselect,
    Sortable,
    PayMethodIcon,
    Multiselect,
    FormInputWrapper,
  },
  setup(props) {
    const store = useStore();
    const state = reactive({
      providers: {} as Dictionary<ProviderDTO>,
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as CascadeFormDTO,
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    function onUpdate(event: any): void {
      if (!event.oldIndex && !event.newIndex) {
        return;
      }

      if (event.newIndex == event.oldIndex) {
        return;
      }

      let items = []
      const item = state.form.providers[event.oldIndex]
      for (const index in state.form.providers) {
        if (index == event.oldIndex) {
          continue;
        }

        item.priority = null
        if (index == event.newIndex && event.newIndex < event.oldIndex) {
          items.push(item)
        }
        items.push(state.form.providers[index])
        if (index == event.newIndex && event.newIndex > event.oldIndex) {
          items.push(item)
        }
      }

      state.form.providers = recalcPriority(items);
    }

    const isProviderLinked = (indexA: number, indexB:number) => {
      if (!state.form.providers[indexB].priority || !state.form.providers[indexA].priority) {
        return false;
      }

      return state.form.providers[indexA].priority === state.form.providers[indexB].priority
    }

    const recalcPriority = (providers: CascadeProviderDTO[]): CascadeProviderDTO[] => {
      let currentPriority = 1

      return providers.map((provider, index) => {
        if (index === 0) {
          return { ...provider, priority: currentPriority }
        }

        const prev = providers[index - 1]

        if (provider.priority !== prev.priority) {
          currentPriority++
        }

        return { ...provider, priority: currentPriority }
      })
    }

    const getBadgeBackground = (priority: number) => {
      const bgClasses = ['bg-dark', 'bg-primary','bg-secondary', 'bg-success']
      const index = (priority - 1) % bgClasses.length

      return bgClasses[index]
    }

    const linkProviders = (indexA:number, indexB:number) => {
      if (isProviderLinked(indexA, indexB)) {
        if (indexA < 0 || indexA >= state.form.providers.length - 1) {
          return;
        }

        const updated = state.form.providers.map((p, i) => {
          if (i === indexA + 1) {
            return { ...p, priority: null }
          }
          return p
        })

        state.form.providers = recalcPriority(updated)

        return;
      }


      const nextPriority = state.form.providers[indexA].priority ?? state.form.providers[indexA + 1].priority

      const updated = state.form.providers.map((p, i) => {
        if (i === indexA || i === indexA + 1) {
          return { ...p, priority: nextPriority }
        }
        return p
      })

      state.form.providers = recalcPriority(updated);
      return;
    }

    const addProvider = () => {
      state.form.providers.push({} as CascadeProviderDTO)
      state.form.providers = recalcPriority(state.form.providers)
    }

    const deleteProvider = (index:number) => {
      state.form.providers = recalcPriority(state.form.providers.filter((item, itemIndex) => itemIndex !== index));
    }

    const selectedRatingTypeOption = computed(() =>
      ratingTypeSelectOptions.find((opt) => opt.value === (state.form.ratingType ?? null))
      ?? ratingTypeSelectOptions[0]
    )

    const ratingTypeOptionLabel = (opt: RatingTypeOption) =>
      helper.trans(ratingTypeLabels[opt.value ?? 'manual'])

    const onRatingTypeSelect = (opt: RatingTypeOption | null) => {
      state.form.ratingType = opt?.value ?? null
    }

    const isValidCoefficient = (value: string | number | null) => {
      const n = parseFloat(value as string)
      return value && !isNaN(n) && n >= 1 && n <= 2
    }

    const validateRating = (form: CascadeFormDTO): ValidationErrorDTO[] => {
      if (!props.providerRatingEnabled || form.ratingType !== 'mix_conversion') return []

      return (['ratingA', 'ratingB', 'ratingC'] as const)
        .filter((field) => !isValidCoefficient(form[field]))
        .map((field) => ({ code: 'RATING_COEFFICIENT_REQUIRED', field, message: '' }))
    }

    const buildPayload = (form: CascadeFormDTO) => ({
      id: form.id,
      name: form.name,
      enabled: form.enabled,
      beforeTraderRequisites: form.beforeTraderRequisites,
      direction: form.direction,
      currency: form.currency,
      minAmount: form.minAmount,
      maxAmount: form.maxAmount,
      paymentOptions: form.paymentOptions,
      paymentMethods: form.paymentMethods,
      storeIds: form.stores.map(item => item.id),
      providers: form.providers,
      ratingType: form.ratingType ?? null,
      ...(form.ratingType === 'mix_conversion'
        ? { ratingA: form.ratingA, ratingB: form.ratingB, ratingC: form.ratingC }
        : {}),
    })

    const save = () => {
      setErrors([]);
      const form = getForm();
      const ratingErrors = validateRating(form)
      if (ratingErrors.length > 0) {
        setErrors(ratingErrors)
        return Promise.reject()
      }

      const payload = buildPayload(form)
      const promise = form.id
        ? api.call.cascades.update(form.id, payload)
        : api.call.cascades.create(payload)

      promise
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
          }
        })

      return promise
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): CascadeFormDTO => {
      return state.form
    }

    const setForm = (form: CascadeFormDTO) => {
      state.errors = {}
      state.form.providers = []
      state.form = {
        ...form,
        ratingType: form.ratingType ?? null,
        ratingA: form.ratingA ?? null,
        ratingB: form.ratingB ?? null,
        ratingC: form.ratingC ?? null,
      }
      if (state.form.providers.length > 0 && state.form.providers[0].priority === 0) {
        state.form.providers = recalcPriority(state.form.providers)
      }
    }

    watch(() => state.form.ratingType, (value) => {
      if (value !== 'mix_conversion') {
        state.form.ratingA = null
        state.form.ratingB = null
        state.form.ratingC = null
      }
    })

    onMounted(async () => {
      const providerById = {} as Dictionary<ProviderDTO>
      let traderIds = []
      const providers = await api.call.providers.all();
      for (const provider of providers) {
        providerById[provider.id] = provider
        traderIds.push(provider.traderId)
      }

      let traderByIds = {} as Dictionary<TraderDTO>
      if (traderIds.length > 0) {
        for (const trader of (await api.traders({limit: traderIds.length, offset: 0} as PaginationDTO, {ids: traderIds})).items) {
          traderByIds[trader.id] = trader
        }
      }

      for (const provider of providers) {
        provider._trader = traderByIds[provider.traderId] ?? null
      }

      state.providers = providerById
    })

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      numberFormatter,
      setErrors,
      getErrors,
      hasErrors,
      save,
      Direction,
      getBadgeBackground,
      deleteProvider,
      linkProviders,
      isProviderLinked,
      addProvider,
      onUpdate,
      ratingTypeSelectOptions,
      selectedRatingTypeOption,
      ratingTypeOptionLabel,
      onRatingTypeSelect,
    }
  }
})
</script>
